/**
 * Main wrapper for all sign up pages
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

import SignUpFooter from './SignUpFooter/SignUpFooter';
import SignUpRoutes from './SignUpRoutes/SignUpRoutes';
import Banner from '../Banner/BannerContainer';

const propTypes = {
  needsEmailVerification: PropTypes.bool.isRequired,
  needsOrg: PropTypes.bool.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    footer: PropTypes.string.isRequired,
  }).isRequired,
  isAuthenticated: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export function UnstyledSignUp({
  classes,
  needsEmailVerification,
  needsOrg,
  isAuthenticated,
  location,
}) {
  const isAWS = location.pathname.includes('aws_onboarding');

  if (isAWS) {
    return (
      <div className={classes.root}>
        <Banner voidPosition />
        <div className={classes.content}>
          <SignUpRoutes
            needsEmailVerification={needsEmailVerification}
            needsOrg={needsOrg}
            isAuthenticated={isAuthenticated}
          />
        </div>
        <SignUpFooter className={classes.footer} />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <Banner voidPosition />
      <div className={classes.content}>
        <SignUpRoutes
          needsEmailVerification={needsEmailVerification}
          needsOrg={needsOrg}
          isAuthenticated={isAuthenticated}
        />
      </div>
      <SignUpFooter className={classes.footer} />
    </div>
  );
}

UnstyledSignUp.propTypes = propTypes;

const styles = (theme) => ({
  root: {
    textAlign: 'center',
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flexGrow: 1,
  },
  footer: {
    flexShrink: 0,
    marginTop: theme.spacing(4),
  },
  banner: {
    position: 'unset',
  },
});

export default withStyles(styles)(UnstyledSignUp);
